import axios from 'axios';
import { GLOBAL_NOTIFICATION_DISPLAY_ID } from 'app/config/constants';

export const fetchActiveGlobalNotification = async (): Promise<string> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/global-notification/active/${GLOBAL_NOTIFICATION_DISPLAY_ID}`)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};
